import { IAuditLogRecord } from './response.types'

/** Значение `context.ticket_type`, которым публикаторы помечают запись о выплате. */
export const AUDIT_TICKET_TYPE_PAYOUT = 'payout_ticket'

/** Значение `context.ticket_type`, которым публикаторы помечают запись о пополнении. */
export const AUDIT_TICKET_TYPE_PAYMENT = 'payment_ticket'

/**
 * Запись однозначно относится к выплате — только по явному `context.ticket_type`.
 * По `kind`, топику или направлению тип тикета не выводится: у записи без метки
 * (старой или не привязанной к тикету) токен остаётся текстом.
 */
export const isPayoutTicketRecord = (rec: IAuditLogRecord): boolean =>
  rec.context?.ticket_type === AUDIT_TICKET_TYPE_PAYOUT

/**
 * Запись однозначно относится к пополнению — тоже только по явной метке. «Не выплата» здесь не
 * годится: запись без метки не относится ни к какому тикету, и ссылка на карточку из неё вела бы
 * в никуда.
 */
export const isPaymentTicketRecord = (rec: IAuditLogRecord): boolean =>
  rec.context?.ticket_type === AUDIT_TICKET_TYPE_PAYMENT
